import { render, staticRenderFns } from "./CourierCatalogByCountry.vue?vue&type=template&id=49694637&"
import script from "./CourierCatalogByCountry.vue?vue&type=script&lang=ts&"
export * from "./CourierCatalogByCountry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports